export const MENU_LIST = [
  { url: "/admin/student", title: "学生管理" },
  { url: "/admin/course", title: "講座管理" },
  { url: "/admin/admin", title: "管理ユーザー管理" },
  { url: "/admin/notification", title: "お知らせ管理" },
];

export const ADMIN_LOGIN = { url: "/admin/login", title: "ログイン" };
export const ADMIN_TOP = { url: "/admin/top", title: "トップ" };

export const UNIV_MENU_LIST = [{ url: "/admin/course", title: "講座管理" }];

export const MYPAGE_MENU_LIST = [
  { url: "/mypage/top", title: "トップページ" },
  { url: "/mypage/user", title: "ユーザー情報の確認・変更" },
  { url: "/mypage/news", title: "お知らせ" },
  { url: "/mypage/course/search/accepting", title: "講座検索" },
  { url: "/mypage/course/search/before", title: "講座検索" },
  { url: "/mypage/course/applied", title: "申込状況・受講履歴" },
  { url: "/mypage/course/attended", title: "申込状況・受講履歴" },
];

export const HTML_TITLE = "渋谷ハチコウ大学";
export const MYPAGE_HTML_TITLE = "渋谷ハチコウ大学マイページ";

export const DEFAULT_DATA_TABLE_LIMIT = "10";

export const PAGE_Limit = [
  { value: "10", label: "10件" },
  { value: "50", label: "50件" },
  { value: "100", label: "100件" },
];

export const MYPAGE_DATA_LIMIT = 8;
export const MAX_PAGINATION_LINK_NUM = 5;

export const AUTH_SHIBUYA = 1;
export const AUTH_UNIVERSITY = 2;

// サイトID
export const OLD_SITE_ID = 4;
export const SITE_ID = 11;

export const COURSE_DETAIL = 1;
export const APPLIED_COURSE = 2;

export const DEFAULT_SCREEN_COLOR = "color-standard";
export const LOCAL_STORAGE_SCREEN_COLOR_KEY = "screen-color";

// CSVアップロード最大サイズ(20MB)
export const MAX_UPLOAD_SIZE = 20971520;

// ハチコウ大学生の最低年齢
export const MIN_STUDENT_AGE = 55;
